import { EthereumNetwork } from "./graphql.js"

export enum Queues {
    tracing = 'tracing',
    report = 'report',
    resolution = 'entity_resolution'
}

export enum ResolutionQueueJobs {
    full = 'full',
}

export enum ReportQueueJobs {
    create = 'create'
}

export enum TracingQueueJobs {
    trace = 'trace',
   // autoTracing = 'auto_tracing',
    cancelTracing = 'cancel_auto_tracing'
}

export enum ContentType {
    MoneyFlow = 'MoneyFlow',
    Report = 'Report'
}

export enum BlockchainNetwork {
    algorand = 'algorand',
    binance = 'binance',
    bitcoin = 'btc',
    cardano = 'cardano',
    conflux = 'conflux',
    cosmos = 'cosmos',
    elrond = 'elrond',
    ethereum = 'eth',
    everscale = 'everscale',
    filecoin = 'filecoin',
    flow = 'flow',
    hedera = 'hedera',
    ripple = 'ripple',
    solana = 'solana',
    stellar = 'stellar',
    tezos = 'tezos',
    tron = 'tron'
}

export const USER_TAG_LIMIT = 3

export enum SelectionModes {
    include = 'include',
    exclude = 'exclude'
}

export const ONE_CURRENCY_BLOCKCHAIN_LIST = [
    BlockchainNetwork.algorand,
    BlockchainNetwork.bitcoin,
    BlockchainNetwork.hedera
]

export const filterKeys = [
    'transfer_sender_address', 'transfer_receiver_address', 'amount_usd', 'currency_smart_contract_address',
    'id', 'tx_timestamp', 'tracing_excluded'
] as const

export const FEATURES = {
    bitcoin: 'btc_chain',
    tron: 'tron_chain',
    forceEntityResolution: 'force_entity_resolution',
    coinpathAPI: 'coinpath_api',
} as const

export const EthereumNetworkNames: Omit<Record<EthereumNetwork, string>, 'ethereum'> = {
    avalanche: 'Avalanche C-chain',
    bsc: 'Binance Smart Chain Mainnet',
    celo_mainnet: 'Celo Mainnet',
    cronos: 'Cronos Mainnet',
    ethclassic: 'Ethereum Classic',
    ethclassic_reorg: 'Ethereum Classic (no reorg from block 10904146)',
    ethpow: 'Ethereum PoW',
    fantom: 'Fantom Mainnet',
    klaytn: 'Klaytn Mainnet',
    matic: 'Matic (Polygon) Mainnet',
    moonbeam: 'Moonbeam Mainnet',
    velas: 'Velas Mainnet',
}

export const BitcoinNetworkNames = {
    bitcoin: 'Bitcoin',
    bitcash: 'Bitcoin Cash',
    bitcoinsv: 'Bitcoin SV',
    dash: 'Dash',
    dogecoin: 'Dogecoin',
    litecoin: 'Litecoin',
    zcash: 'ZCash',
}

export const CosmosNetwork = {
    cosmoshub: 'cosmoshub',
    crypto_mainnet: 'crypto_mainnet',
}
